import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "../../config/axios";
import { useCatalogQuery, useProductsById } from "../../Hooks/useProductsBySubCategory";
import moment from "../../config/moment";

import { useNavigate } from "react-router-dom";

// importing components
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Popover,
  Progress,
  Rate,
  Row,
  Tabs,
  message,
} from "antd";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
// import FrequentlyBoughtTogether from '../../Components/FrequentlyBoughtTogether/FrequentlyBoughtTogether';
import Loader from "../../Components/Loader/Loader";
import ProductArticleDetails from "../../Components/ProductArticleDetails/ProductArticleDetails";
import ProductContactInfo from "../../Components/ProductContactInfo/ProductContactInfo";
import ProductDescriptionSlider from "../../Components/ProductDescriptionSlider/ProductDescriptionSlider";
import ProductIngredientInfo from "../../Components/ProductIngredientInfo/ProductIngredientInfo";
import ProductNutritionalInfo from "../../Components/ProductNutritionalInfo/ProductNutritionalInfo";
import ProductQAInfo from "../../Components/ProductQAInfo/ProductQAInfo";
import ProductReviewInfo from "../../Components/ProductReviewInfo/ProductReviewInfo";
import ProductSlider from "../../Components/Sliders/ProductSlider/ProductSlider";

// importing utils
import {
  getVariantImage,
  getVariantPrice,
  percentageCalculator,
  sortVariantsByPrice,
} from "../../utils/helpers";

// importing styles
import styles from "./ProductDescription.module.scss";

// importing images
import Contactless from "./images/contactless.svg";
import FreeDelivery from "./images/freeDelivery.svg";
import GlutenFree from "./images/gluten_free.svg";
import NonRefundable from "./images/nonRefundable.svg";
import paymentMethodsImage from "./images/payment_methods.svg";
import Refundable from "./images/refundable.svg";
import Vegan from "./images/vegan.svg";

// importing icons
import { BiChevronRight } from "react-icons/bi";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { HiMail } from "react-icons/hi";
import { IoMdShareAlt } from "react-icons/io";

// importing contexts
import { BsArrowLeft, BsArrowRight, BsArrowRightShort } from "react-icons/bs";
import { FeatureFlag } from "../../Components/FeatureFlag/FeatureFlag";
import FrequentlyBoughtTogether from "../../Components/FrequentlyBoughtTogether/FrequentlyBoughtTogether";
import { CartContext } from "../../Contexts/CartContext";
import { AuthContext } from "../../Contexts/AuthContext";
import { RecommendedProducts } from "../LandingV2/LandingV2";
// import FrequentlyBoughtTogether from "../../Components/FrequentlyBoughtTogether/FrequentlyBoughtTogether";

const FreeShippingCart = () => {
  const cartContext = useContext(CartContext);


  return (
    <div styl={{ position: "fixed", top: 40 }}>
      {cartContext.calculateOrderSubTotal() > 39.99 ? (
        <>
          <div
            style={{
              background: "#F7EAC8",
              display: "flex",
              gap: "10px",
              padding: ".5rem 1rem",
              alignItems: "center",
            }}
          >
            <img
              src="https://desi-fresh.b-cdn.net/misc/df-db-hand.svg"
              alt=""
            />
            <span style={{ fontSize: "13px" }}>
              Congrats! You get a free shipping on this order
            </span>
          </div>
        </>
      ) : (
        <div style={{ padding: 10, backgroundColor: "#ddd" }}>
          <Progress
            strokeColor={{
              "0%": "var(--color-primary)",
              "100%": "#87d068",
            }}
            percent={(100 * cartContext.calculateOrderSubTotal()) / 39.99}
            showInfo={false}
            status="active"
          />
          <span>
            Please add{" "}
            <span
              style={{
                fontSize: "1.6rem",
                fontWeight: "bold",
                color: "var(--color-dark)",
              }}
            >
              €
              {parseFloat(49.99 - cartContext.calculateOrderSubTotal()).toFixed(
                2
              )}
            </span>{" "}
            worth product to obtain free delivery
          </span>
        </div>
      )}
    </div>
  );
};

const ProductDescription = () => {
  const cartContext = useContext(CartContext);
  const { location } = useContext(AuthContext);
  const navigate = useNavigate();

  const { slug } = useParams();
  const [selectedVariantId, setSelectedVariantId] = useState(null);
  const [quantity, setQuantity] = useState(0);
  const [productInCart, setProductInCart] = useState(false);
  const tabBarRef = useRef(null);
  const [showDiscountPopover, setShowDiscountPopover] = useState(false);
  const [showReportFalseModal, setShowReportFalseModal] = useState(false);
  const [showFreeShippingCart, setShowFreeShippingCart] = useState(false);

  const { data: productData } = useCatalogQuery(`/public/products/${slug}`);
  const product = productData ?? null;

  // frequently bought together, complete a bundle and recommended products
  const fbt = useProductsById(product?.fbt);
  const cab = useProductsById(product?.cab);
  const rp = useProductsById(product?.rp);

  const { data: reviewCount = 0 } = useCatalogQuery("/public/reviews", {
    params: { product: product?.id },
    transform: (data) => data.count,
    enabled: !!product,
  });

  // derived during render so it is never null while a product is shown (a
  // cached product renders before any effect runs). A background refetch of
  // the same product keeps the picked variant, a new product starts on its
  // cheapest one
  const selectedVariant = product
    ? product.variants?.find((variant) => variant.id === selectedVariantId) ??
      sortVariantsByPrice(product.variants ?? [])[0] ??
      null
    : null;
  const setSelectedVariant = (variant) => setSelectedVariantId(variant.id);
  const finalPrice = selectedVariant ? getVariantPrice(selectedVariant) : 0.0;

  // when user comes this page, save the product
  useEffect(() => {
    if (!product) return;

    // set product in recently viewed local storage, maximum 6
    let recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed"));
    if (recentlyViewed) {
      if (recentlyViewed.length >= 6) {
        recentlyViewed.pop();
      }
      recentlyViewed.unshift(product);

      // remove duplicates
      recentlyViewed = recentlyViewed.filter(
        (item, index, self) =>
          self.findIndex((t) => t.id === item.id) === index
      );
      localStorage.setItem("recentlyViewed", JSON.stringify(recentlyViewed));
    } else {
      localStorage.setItem("recentlyViewed", JSON.stringify([product]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product?.id]);

  useEffect(() => {
    if (product) {
      setProductInCart(false);
      if (cartContext.cartItems) {
        for (let i = 0; i < cartContext.cartItems.length; i++) {
          if (cartContext.cartItems[i].id === product.id) {
            console.log(cartContext.cartItems[i]);
            setProductInCart(true);
            setQuantity(cartContext.cartItems[i].quantity);
            break;
          }
        }
      }
    }
  }, [...Object.values(cartContext), product]);

  const displayFreeShippingCart = () => {
    setShowFreeShippingCart(true);
    setTimeout(() => {
      setShowFreeShippingCart(false);
    }, 3000);
  };

  //defining increaseQty function
  const increaseQty = () => {
    setShowDiscountPopover(true);
    displayFreeShippingCart();
    if (!productInCart) {
      setQuantity(quantity + 1);
    } else {
      addToCart();
    }
    //todo:max stock check
  };

  const decreaseQty = () => {
    displayFreeShippingCart();
    if (quantity - 1 < 0) {
      setQuantity(0);
    } else {
      cartContext.cartItemDecrement(product.id);
      setQuantity(quantity - 1);
    }
    setShowDiscountPopover(true);
  };

  const addToCart = () => {
    let item = {
      id: product.id,
      title: product.title,
      slug: product.slug,
      tax_rate: product.tax_rate,
      order_time_price: finalPrice,
      image: getVariantImage(selectedVariant, product.variants),
      quantity: quantity,
      stock: selectedVariant.stock,
      product: product,
      variant: selectedVariant,
    };

    cartContext.addToCart(item);
  };

  const RenderProductVariant = () => {
    const [isOpen, setIsOpen] = useState(false);

    // cheapest variant first
    const variants = sortVariantsByPrice(product.variants);
    return (

      <div className={`${styles.variant} ${variants.length <= 3 ? styles.variant_mobile : ""}`}>
        {(window.innerWidth <= 576 && variants.length > 3) ?
          <>
            {/* MOBILE VERSION WITH DROPDOWN AFTER 3rd QUANTITY */}
            <div className={styles.variant_header}>
              <div className={styles.variant_select_title}>Quantity</div>
              <div className={styles.variant_more} onClick={() => setIsOpen(!isOpen)}>
                <span>Show more</span>
                <img src={`${isOpen ? "/icon/chevron-up.svg" : "/icon/chevron-down.svg"}`} alt="dropdown arrow" />
              </div>
            </div>
            <div className={`${styles.variant_select_wrapper} ${isOpen ? styles.variant_select_wrapper_open : ""}`}>
              <div className={`${styles.variant_select} ${styles.variant_select_dropdown}`}>
                {variants.map((variant, index) => (
                  <div
                    key={index}
                    onClick={() => setSelectedVariant(variant)}
                    className={
                      variant.value === selectedVariant.value
                        ? `${styles.variant_option} ${styles.variant_option_selected}`
                        : styles.variant_option
                    }
                  >
                    {variant.value}
                  </div>
                ))}
              </div>

            </div>
          </>
          :
          <>
            {/* DESKTOP VERSION */}
            <div className={styles.variant_select_title}>Quantity</div>
            <div className={styles.variant_select}>
              {variants.map((variant, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedVariant(variant)}
                  className={
                    variant.value === selectedVariant.value
                      ? `${styles.variant_option} ${styles.variant_option_selected}`
                      : styles.variant_option
                  }
                >
                  {variant.value}
                </div>
              ))}
            </div>
          </>
        }
      </div>
    )
  }

  const renderProductTitle = () => (
    <>
      <div className={styles.product_title}>
        <span>{product.title}</span>
        <span style={{ textWrap: "nowrap" }}>Best Seller</span>
      </div>
      <div className={styles.brand_info}>
        <span>Brand: </span>
        <span>
          <Link to={`/brand/${product.brand.slug}_${product.brand.id}`}>
            {product.brand.name}
          </Link>
        </span>
      </div>
      {/* stock check and seller */}
      <div className={styles.stockCheck}>
        {selectedVariant.stock > 0 ? (
          <span>In Stock</span>
        ) : (
          <span className="bg-danger text-light">
            Out of Stock
          </span>
        )}

      </div>
    </>
  );

  const renderProductPrice = () => (
    <div className={styles.price}>
      <span className={styles.price_main}>
        {" "}
        {finalPrice.toFixed(2)} €
        {selectedVariant?.discount_percentage ? (
          <s className={styles.price_beforeDiscount}>
            {" "}
            ({parseFloat(selectedVariant.price).toFixed(2)} €)
          </s>
        ) : null}
      </span>
      <div className={styles.ca}>
        Ca. {selectedVariant.value} (1kg = 0.99€){" "}
      </div>
      {/* <div className={styles.ca}>Inclusive of {product.tax_rate}% VAT</div> */}
    </div>
  );

  // sliding and scrolling management here
  const targetRef = useRef(null);
  const handleClickRight = () => {
    const { current: target } = targetRef;
    if (target) {
      target.scrollTo({
        left: target.scrollLeft + 100, // Scroll 100 pixels to the right
        behavior: "smooth",
      });
    }
  };

  const handleClickLeft = () => {
    const { current: target } = targetRef;
    if (target) {
      target.scrollTo({
        left: target.scrollLeft - 100, // Scroll 100 pixels to the right
        behavior: "smooth",
      });
    }
  };

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (event) => {
    event.preventDefault();
    setIsDragging(true);
    setStartX(event.pageX - targetRef.current.offsetLeft);
    setScrollLeft(targetRef.current.scrollLeft);
  };

  const handleMouseMove = (event) => {
    if (!isDragging) return;
    event.preventDefault();
    const x = event.pageX - targetRef.current.offsetLeft;
    const distanceX = (x - startX) * 1.5;
    targetRef.current.scrollLeft = scrollLeft - distanceX;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // sliding and scrolling management ends here

  const Collapsable = ({ header, children }) => {
    const [open, setOpen] = useState(false);

    return (
      <div className={styles.collapsable}>
        <div className={styles.collapsable_header} onClick={() => setOpen(!open)}>
          <span>{header}</span>
          <img src={open ? "/icon/chevron-up.svg" : "/icon/chevron-down.svg"} alt={open ? "arrow up" : "arrow down"} />
        </div>
        <div className={`${styles.collapsable_content} ${open ? styles.collapsable_content_open : ""}`}>
          {children}
        </div>
      </div>
    )
  }

  return (
    <Layout title={product ? product.title + " - Desi Fresh" : "Desi Fresh"} >
      {showFreeShippingCart ? <FreeShippingCart /> : null}

      {product && selectedVariant ? (
        <div className={styles.productDescriptionWrapper}>
          <div className="container">
            {/* breadcrumb section */}
            <Row>
              <Col lg={0} xs={24}>
                <BreadCrumb
                  list={[
                    {
                      name: "Home",
                      link: "/",
                    },
                    {
                      name: product?.title,
                      link: `/products/${product?.slug}`,
                    },
                  ]}
                />
              </Col>
              <Col lg={24} xs={0} style={{ marginTop: 15 }}>
                <BreadCrumb
                  list={[
                    {
                      name: "Back to Home",
                      link: "/",
                    },
                    {
                      name: `Product - ${product?.title}`,
                      link: `/products/${product?.slug}`,
                    },
                  ]}
                />
              </Col>
            </Row>

            <div className={styles.productDescription}>
              <Row gutter={[5, 5]}>
                <Col lg={18}>
                  <Row gutter={[16, 16]}>
                    <Col lg={24}>
                      <Row gutter={window.innerWidth < 576 ? [0, 0] : [30, 30]}>
                        <Col lg={10} style={{ width: "100%" }}>
                          <ProductDescriptionSlider
                            product={product}
                            variant={selectedVariant}
                          />
                          <div className="dt_only">
                            {/* about this product section */}
                            <div className={styles.aboutThisProduct}>
                              <div className={styles.aboutThisProduct_title}>
                                About this product
                              </div>
                              <div className={styles.aboutThisProduct_desc}>
                                {product.about_this_product}
                              </div>
                              <div
                                className={
                                  styles.aboutThisProduct_desc_additional
                                }
                                onClick={() =>
                                  tabBarRef.current.scrollIntoView()
                                }
                              >
                                <span>See additional product details </span>
                                <BiChevronRight
                                  size={20}
                                  color={"var(--color-primary)"}
                                />
                              </div>
                            </div>
                            {/* report false section */}
                            <div
                              className={styles.reportFalse}
                              onClick={() => {
                                setShowReportFalseModal(true);
                              }}
                            >
                              <HiMail size={20} />
                              <span>
                                Report false or incorrect product information{" "}
                              </span>
                            </div>

                            {
                              // show report false modal
                              showReportFalseModal && (
                                <ReportFalseModal
                                  visible={showReportFalseModal}
                                  setVisible={setShowReportFalseModal}
                                  productId={product.id}
                                />
                              )
                            }
                          </div>
                        </Col>
                        <Col lg={14} xs={24}>
                          <div className="position-relative">
                            <div
                              id="customProductDescriptionSliderPortal"
                              className="position-absolute top-0 start-0 border rounded-4 overflow-hidden"
                              style={{
                                zIndex: 99,
                                marginLeft: -25,
                              }}
                            />

                            <div className={styles.productDescription_middle}>
                              {product.filter_attr === "bestseller" && (
                                <div
                                  className={`${styles.best_seller_dt} dt_only`}
                                >
                                  Best Seller
                                </div>
                              )}

                              <div className={styles.sm_none}>
                                {renderProductTitle()}
                              </div>

                              <div
                                className={`${styles.product_info_wrapper} ${styles.lg_none}`}
                              >
                                <div className={styles.product_info_wrapper_title}>
                                  <div className={styles.product_title_wrapper}>
                                    {renderProductTitle()}
                                  </div>
                                  <div className={styles.product_price_wrapper}>
                                    {renderProductPrice()}
                                  </div>
                                </div>

                                <div className={styles.review}>
                                  <div className={styles.review_left}>
                                    <span>
                                      <Rate
                                        disabled
                                        allowHalf
                                        style={{ fontSize: 14, color: "#fed304" }}
                                        defaultValue={+product.rating}
                                      />
                                    </span>
                                    <span> ({reviewCount} Reviews)</span>
                                  </div>
                                </div>

                                <div className={styles.product_variant_wrapper}>
                                  <RenderProductVariant />
                                </div>
                              </div>

                              {/* mobile tab bar */}
                              <div
                                className={`mobile_product_tab_bar ${styles.mobile_product_tab_bar}`}
                              >
                                <Row gutter={[10, 10]}>
                                  <Col span={24}>
                                    <Collapsable header="Product details">
                                      <ProductArticleDetails product={product} selectedVariant={selectedVariant} />
                                      <span className={styles.collapsable_secondary_header}>Nutritional information</span>
                                      <ProductNutritionalInfo product={product} />
                                      <span className={styles.collapsable_secondary_header}>Ingredients & Allergen information</span>
                                      <ProductIngredientInfo product={product} />
                                    </Collapsable>

                                  </Col>

                                  <Col span={24}>
                                    <Collapsable header="Reviews">
                                      <ProductReviewInfo
                                        productId={product.id}
                                        selectedVariant={selectedVariant}
                                      />
                                    </Collapsable>
                                  </Col>

                                  <Col span={24} >
                                    <Collapsable header="Q&A">
                                      <ProductQAInfo productId={product.id} />
                                    </Collapsable>
                                  </Col>
                                </Row>
                              </div>

                              <Divider style={{ margin: "10px 0" }} />

                              {/* variant section */}
                              <div className={styles.sm_none}>
                                <RenderProductVariant />
                              </div>

                              <Row>
                                <Col lg={24} xs={0}>
                                  <div
                                    className={styles.fresh_authentic_wrapper}
                                  >
                                    <div className={styles.fresh_authentic}>
                                      Fresh and Authentic
                                    </div>
                                  </div>
                                  <div className={styles.pro_det}>
                                    Product details
                                  </div>

                                  <Row>
                                    <Col span={6}>
                                      <div>
                                        <strong>Brand</strong>
                                      </div>
                                      <div>
                                        <strong>Weight</strong>
                                      </div>
                                      <div>
                                        <strong>Number of Items</strong>
                                      </div>
                                    </Col>
                                    <Col span={18}>
                                      <div
                                        style={{
                                          color: "var(--color-primary)",
                                          fontWeight: "bold",
                                          textDecorationLine: "underline",
                                        }}
                                      >
                                        <Link
                                          to={`/brand/${product.brand.slug}_${product.brand.id}`}
                                        >
                                          {product.brand.name}
                                        </Link>
                                      </div>
                                      {/* <div>Nacho Cheese</div> */}
                                      <div>{selectedVariant.value}</div>
                                      {/* <div>50 Count (Pack of 1)</div> */}
                                      {/* <div>{selectedVariant.stock}</div> */}
                                      <div>1</div>
                                    </Col>
                                  </Row>

                                  {(product.is_gluten_free ||
                                    product.is_vegan ||
                                    product.is_refundable ||
                                    product.has_free_delivery ||
                                    product.is_non_refundable ||
                                    product.has_contactless_delivery) && (
                                      <Row
                                        style={{ marginTop: 20 }}
                                        gutter={[20, 20]}
                                      >
                                        <Col span={2}>
                                          <div
                                            className={styles.arrow}
                                            onClick={handleClickLeft}
                                          >
                                            <BsArrowLeft size={22} />
                                          </div>
                                        </Col>
                                        <Col span={20}>
                                          <div
                                            className={
                                              styles.productDescription_features
                                            }
                                            ref={targetRef}
                                            onMouseDown={handleMouseDown}
                                            onMouseMove={handleMouseMove}
                                            onMouseUp={handleMouseUp}
                                            onMouseLeave={handleMouseUp}
                                          >
                                            {product.is_gluten_free && (
                                              <div
                                                className={
                                                  styles.productDescription_features_content
                                                }
                                              >
                                                <img
                                                  src={GlutenFree}
                                                  alt={"gluten free"}
                                                />
                                                <div>Gluten Free</div>
                                              </div>
                                            )}
                                            {product.is_vegan && (
                                              <div
                                                className={
                                                  styles.productDescription_features_content
                                                }
                                              >
                                                <img
                                                  src={Vegan}
                                                  alt={"gluten free"}
                                                />
                                                <div>Vegan</div>
                                              </div>
                                            )}
                                            {product.is_refundable && (
                                              <div
                                                className={
                                                  styles.productDescription_features_content
                                                }
                                              >
                                                <img
                                                  src={Refundable}
                                                  alt={"gluten free"}
                                                />
                                                <div>Refundable</div>
                                              </div>
                                            )}
                                            {product.has_free_delivery && (
                                              <div
                                                className={
                                                  styles.productDescription_features_content
                                                }
                                              >
                                                <img
                                                  src={FreeDelivery}
                                                  alt={"gluten free"}
                                                />
                                                <div>Free Delivery</div>
                                              </div>
                                            )}
                                            {product.is_non_refundable && (
                                              <div
                                                className={
                                                  styles.productDescription_features_content
                                                }
                                              >
                                                <img
                                                  src={NonRefundable}
                                                  alt={"gluten free"}
                                                />
                                                <div>Non Refundable</div>
                                              </div>
                                            )}
                                            {product.has_contactless_delivery && (
                                              <div
                                                className={
                                                  styles.productDescription_features_content
                                                }
                                              >
                                                <img
                                                  src={Contactless}
                                                  alt={"gluten free"}
                                                />
                                                <div>Contactless Delivery</div>
                                              </div>
                                            )}
                                          </div>
                                        </Col>
                                        <Col span={2}>
                                          <div
                                            className={styles.arrow}
                                            onClick={handleClickRight}
                                          >
                                            <BsArrowRight size={22} />
                                          </div>
                                        </Col>
                                      </Row>
                                    )}

                                  <Divider
                                    style={{
                                      margin: "2rem 0",
                                    }}
                                  />

                                  <Row>
                                    <Col span={24}>
                                      <div className={styles.pro_det}>
                                        Delivery
                                      </div>
                                      <ProductDeliveryInfo
                                        product={product}
                                        isDesktop
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              {/* price */}
                              <div className={styles.sm_none}>
                                {renderProductPrice()}
                              </div>

                              {/* offer expired section */}
                              {selectedVariant.discount_percentage &&
                                selectedVariant.sale_end_date && (
                                  <div className={styles.offerExpired}>
                                    <span>
                                      Offer valid till{" "}
                                      {moment(product.sale_end_date).format(
                                        "MM.DD.YY"
                                      )}
                                    </span>
                                    <span>250g (1kg = 1.56€)</span>
                                  </div>
                                )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} xs={24}>
                  {/* add to cart top */}
                  <div
                    className="dt_only"
                    style={{
                      boxShadow: "0px 2px 5px 1px rgba(0, 0, 0, 0.05)",
                      padding: "1rem",
                    }}
                  >
                    <Link to={"/"}>
                      <Button block className={styles.cts_btn}>
                        <span>
                          <strong>Continue to shopping</strong>
                        </span>
                        <BsArrowRightShort size={22} />
                      </Button>
                    </Link>
                  </div>

                  <div className={styles.extraInformation}>
                    <div>
                      <img
                        src="https://desi-fresh.b-cdn.net/components_static/ProductDescription/desi_hands.svg"
                        alt="hands"
                      />
                      <div className={styles.extra_info_text}>
                        Your purchase helps underprivileged children{" "}
                      </div>
                    </div>
                    <div>
                      <img
                        src="https://desi-fresh.b-cdn.net/components_static/ProductDescription/free_shipping.svg"
                        alt="free_shipping"
                      />
                      <div className={styles.extra_info_text}>
                        Get free shipping at 49€{" "}
                      </div>
                    </div>
                  </div>

                  {/* price, stock, payment, hidden in mobile now */}
                  <div className={`${styles.priceStockPayment} hide_mobile`}>
                    {/* price and vat text section */}
                    <div className={styles.priceVatWrapper}>
                      <div className={styles.priceVat}>
                        <div className={styles.priceVat_top}>
                          <div className={styles.bigPrice}>
                            {finalPrice.toFixed(2).split(".")[0]}.
                          </div>
                          <div className={styles.smallPrice}>
                            {finalPrice.toFixed(2).split(".")[1]} €
                          </div>
                          {percentageCalculator(
                            selectedVariant?.price,
                            selectedVariant?.discount_percentage
                          ) > 0 && (
                              <div className={styles.discount}>
                                (
                                {percentageCalculator(
                                  selectedVariant?.price,
                                  selectedVariant?.discount_percentage
                                ).toFixed(2) + "€"}
                                )
                              </div>
                            )}
                        </div>

                        <div className="text-start">
                          {selectedVariant.discount_percentage &&
                            selectedVariant.sale_end_date && (
                              <div className={styles.offerExpired}>
                                <span>
                                  Offer valid till{" "}
                                  {moment(product.sale_end_date).format(
                                    "MM.DD.YY"
                                  )}
                                </span>
                              </div>
                            )}
                        </div>

                        {/* <div className="text-start">
                                                    <div className={styles.priceVatAmount}>Each 300g Glass (10.73€/kg)</div>
                                                </div> */}

                        <div className="text-start">
                          <div className={styles.priceVatAmount}>
                            Inclusive of {product.tax_rate}% VAT
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles.addToCartTopDt}>
                      {quantity ? (
                        <div style={{ flex: 1 }} className={styles.stock_control}>
                          <img
                            height={22}
                            src={
                              "https://desi-fresh.b-cdn.net/components_static/minus_qty.svg"
                            }
                            alt="minus"
                            onClick={decreaseQty}
                          />
                          <Popover
                            open={showDiscountPopover}
                            content={
                              <DiscountPopContent
                                price={finalPrice}
                                quantity={quantity}
                              />
                            }
                            trigger="click"
                            onOpenChange={(visible) =>
                              setShowDiscountPopover(visible)
                            }
                            placement="topLeft"
                            overlayInnerStyle={{ width: 250 }}
                            arrowPointAtCenter
                          >
                            <div className={styles.stock_amount}>
                              {quantity}
                            </div>
                          </Popover>

                          <img
                            height={22}
                            src={
                              "https://desi-fresh.b-cdn.net/components_static/plus_qty.svg"
                            }
                            alt="plus"
                            onClick={increaseQty}
                          />
                        </div>
                      ) : (
                        <button
                          style={{
                            backgroundColor: productInCart
                              ? "var(--color-primary)"
                              : null,
                            flex: 1
                          }}
                          className={styles.addToCartTop_btn}
                          onClick={() => addToCart()}
                        >
                          <img
                            className={styles.addToCartTop_img}
                            src={
                              "https://desi-fresh.b-cdn.net/components_static/ProductDescription/cart_add.svg"
                            }
                            alt="cart"
                          />{" "}
                          Add to Cart
                        </button>
                      )}
                      <FeatureFlag name="saveForLater">
                        <img
                          className={styles.bookmark_img}
                          src={
                            "https://desi-fresh.b-cdn.net/components_static/ProductDescription/bookmark.svg"
                          }
                          alt="bookmark"
                        />
                      </FeatureFlag>
                    </div>

                    {/* add to list button section */}
                    <div className={styles.addToListWrapper}>
                      <button
                        className={styles.addToList_btn}
                        onClick={() => {
                          message.info("We are working on this feature.");
                        }}
                      >
                        Add to List
                        <img
                          className={styles.addToList_img}
                          src={
                            "https://desi-fresh.b-cdn.net/misc/add_to_list.svg"
                          }
                          alt="add to list"
                        />
                      </button>
                    </div>

                    {/* extraInformation for desktop */}
                    <div className={styles.extraInformationDt}>
                      <div>
                        <img
                          src="https://desi-fresh.b-cdn.net/components_static/ProductDescription/desi_hands.svg"
                          alt="hands"
                        />
                        <div className={styles.extra_info_text}>
                          Your purchase helps underprivileged children{" "}
                        </div>
                      </div>
                      <div>
                        <img
                          src="https://desi-fresh.b-cdn.net/components_static/ProductDescription/free_shipping.svg"
                          alt="free_shipping"
                        />
                        <div className={styles.extra_info_text}>
                          Get free shipping at 49€{" "}
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{
                        margin: "10px 0",
                      }}
                    />

                    {/* subscribe and save 5% section */}
                    <FeatureFlag name="subscribeAndSave">
                      <div className={`${styles.subscribeSave}`}>
                        <div className={styles.subscribeSave_left}>
                          <Checkbox
                            onChange={(e) => {
                              console.log(e.target.checked);
                            }}
                          />
                        </div>
                        <div className={styles.subscribeSave_right}>
                          <p>Subscribe & Save 5% </p>
                          <p>1,89 € (7,56 €/kg)</p>
                          <p>First delivery on Sept 21</p>
                        </div>
                      </div>
                    </FeatureFlag>

                    {/* accepted payment methods image */}
                    <div className={styles.acceptedPaymentMethods}>
                      <img src={paymentMethodsImage} alt="payment" />
                    </div>
                  </div>
                  {/* membership card */}
                  <FeatureFlag name="membership">
                    <div className={`${styles.membershipCard}`}>
                      <div className={styles.membershipCard_left}>
                        <img
                          src={
                            "https://desi-fresh.b-cdn.net/misc/family_card.svg"
                          }
                          alt="membership"
                        />
                      </div>
                      <div className={styles.membershipCard_right}>
                        <p>
                          <strong>Earn, Save & Redeem Points</strong> <br />1
                          point per 2 euro spent.
                        </p>
                        <div>
                          <span>Not a member?</span>
                          <span className={styles.join_now_btn}>Join Now</span>
                        </div>
                      </div>
                    </div>
                  </FeatureFlag>

                  {/* fast delivery card */}
                  <div className={styles.fastDeliveryCard + " hide_mobile"}>
                    <div className={styles.fastDeliveryCard_left}>
                      <img
                        src={
                          "https://desi-fresh.b-cdn.net/misc/fast_delivery.svg"
                        }
                        alt="fast_delivery"
                      />
                    </div>
                    <div
                      className={styles.fastDeliveryCard_right + " hide_mobile"}
                    >
                      <p>Guaranteed Fast Delivery</p>
                      <p>Free standard delivery on orders above 50 Euro</p>
                    </div>
                  </div>
                  {/* social share card */}
                  <div className={styles.socialShareCardWrap + " hide_mobile"}>
                    <div className={styles.share_title}>Share this product</div>
                    <div className={styles.socialShareCard}>
                      <div
                        className={styles.icons_container}
                        onClick={() => {
                          window.open(
                            `https://www.facebook.com/sharer/sharer.php?u=https://desifresh.co/products/${product.slug}`,
                            "facebook-share-dialog",
                            "width=800,height=600"
                          );
                        }}
                      >
                        <FaFacebookF size={24} />
                      </div>
                      <div
                        className={styles.icons_container}
                        onClick={() => {
                          window.open(
                            `https://www.linkedin.com/shareArticle?mini=true&url=https://desifresh.co/products/${product.slug}`,
                            "linkedin-share-dialog",
                            "width=800,height=600"
                          );
                        }}
                      >
                        <FaLinkedinIn size={24} />
                      </div>
                      <div
                        className={styles.icons_container}
                        onClick={() => {
                          window.open(
                            `https://twitter.com/intent/tweet?text=https://desifresh.co/products/${product.slug}`,
                            "twitter-share-dialog",
                            "width=800,height=600"
                          );
                        }}
                      >
                        <FaTwitter size={24} />
                      </div>
                      <div
                        className={styles.icons_container}
                        onClick={() => {
                          // open email client but not the browser
                          window.location.href = `mailto:?subject=Check out this product on Desi Fresh&body=https://desifresh.co/products/${product.slug}`;
                        }}
                      >
                        <FiMail size={24} />
                      </div>
                      <div
                        className={styles.icons_container}
                        onClick={() => {
                          // copy to clipboard
                          window.navigator.clipboard.writeText(
                            `https://desifresh.co/products/${product.slug}`
                          );
                          message.success("Link copied to clipboard");
                        }}
                      >
                        <IoMdShareAlt size={24} />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            {/* frequently bought together component */}
            {fbt.length > 0 && (
              <div style={{ marginTop: 50, marginBottom: 50 }}>
                <FrequentlyBoughtTogether products={fbt} />
              </div>
            )}

            {/* product description tab bar section */}
            <div className={styles.tabBarWrapper} ref={tabBarRef}>
              <div className="custom_product_desc_tab">
                <Tabs
                  defaultActiveKey="1"
                  tabPosition="top"
                  animated={{
                    inkBar: true,
                    tabPane: true,
                  }}
                >
                  {product.facts && JSON.parse(product?.facts) !== "[]" ? (
                    <Tabs.TabPane tab="Nutritional information" key="1">
                      <ProductNutritionalInfo product={product} />
                    </Tabs.TabPane>
                  ) : null}

                  {product.nutri_score && (
                    <Tabs.TabPane
                      tab="Ingredients & Allergen information "
                      key="2"
                    >
                      <ProductIngredientInfo product={product} />
                    </Tabs.TabPane>
                  )}

                  <Tabs.TabPane tab="Article details" key="3">
                    <ProductArticleDetails
                      product={product}
                      selectedVariant={selectedVariant}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Q&A’s" key="4">
                    <ProductQAInfo productId={product.id} />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Contact" key="5">
                    <ProductContactInfo product={product} />
                  </Tabs.TabPane>
                </Tabs>
              </div>
            </div>



            <Divider className="hide_mobile" />

            <div className={styles.hidden_mobile}>
              <ProductReviewInfo
                productId={product.id}
                selectedVariant={selectedVariant}
              />
            </div>

            {/* Customers also buy these products slider */}
            {cab.length > 0 && (
              <ProductSlider
                title="Customers also buy these products"
                products={cab}
              />
            )}
          </div>
        </div>
      ) : (
        <>
          <Loader height={"50vh"} />
        </>
      )}

      {/* floating card render when cart have something */}
      {(window.innerWidth < 768 && location) && (
        <div className={styles.addToCartFixedBottom}>
          <div style={{ gap: 4 }} className={styles.addToCartTopMb}>
            {!quantity ? (
              <button
                style={{
                  backgroundColor: productInCart
                    ? "var(--color-primary)"
                    : null,
                }}
                className={`${styles.addToCartTop_btn} ${styles.fixed_add_to_cart_button}`}
                onClick={() => addToCart()}
              >
                <img
                  className={styles.addToCartTop_img}
                  src={
                    "https://desi-fresh.b-cdn.net/components_static/ProductDescription/cart_add.svg"
                  }
                  alt="cart"
                />
                <span>Add to Cart</span>
              </button>
            ) : (
              <>
                <div style={{ flex: 2 }} className={styles.stock_control}>
                  <img
                    height={22}
                    src={
                      "https://desi-fresh.b-cdn.net/components_static/minus_qty.svg"
                    }
                    alt="minus"
                    onClick={decreaseQty}
                  />

                  <Popover
                    open={showDiscountPopover}
                    content={
                      <DiscountPopContent
                        price={finalPrice}
                        quantity={quantity}
                      />
                    }
                    trigger="click"
                    onOpenChange={(visible) => setShowDiscountPopover(visible)}
                    placement="topLeft"
                    overlayInnerStyle={{ width: 250 }}
                    arrowPointAtCenter
                  >
                    <div className={styles.stock_amount}>{quantity}</div>
                  </Popover>

                  <img
                    height={22}
                    src={
                      "https://desi-fresh.b-cdn.net/components_static/plus_qty.svg"
                    }
                    alt="plus"
                    onClick={increaseQty}
                  />
                </div>

                {quantity && (
                  <button
                    style={{
                      backgroundColor: productInCart
                        ? "var(--color-primary)"
                        : null,
                      flex: 1
                    }}
                    className={`${styles.addToCartTop_btn} ${styles.fixed_add_to_cart_button}`}
                    onClick={() => navigate("/cart-checkout")}
                  >
                    <span>To Checkout</span>
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {window.innerWidth < 576 &&
        <div style={{ marginTop: "2rem" }}>
          <RecommendedProducts />
        </div>
      }

      {/* related product slider */}
      {product && rp.length > 0 && (
        <div className="container">
          <ProductSlider title="Recommended products" products={rp} />
        </div>
      )}

      {/* recommended product slider */}
      {product && rp.length > 0 && (
        <div className="container">
          <ProductSlider title="Recommended products" products={rp} />
        </div>
      )}
    </Layout>
  );
};

export default ProductDescription;

// productDeliveryInfo
const ProductDeliveryInfo = ({ product, isDesktop }) => {
  const info = [
    {
      title: "Standard Free Delivery",
      from: "From 49€, Max. 30kg box",
      delivery:
        "Quick delivery within 1-2 days within Munich and 3-4 days rest of the Germany (Excluding holidays)",
    },
    {
      title: "Standard Delivery (4.50€)",
      from: "Below 49€, Max. 30kg box",
      delivery:
        "Quick delivery within 1-2 days within Munich and 3-4 days rest of the Germany (Excluding holidays)",
    },
    {
      title: "Express Delivery",
      from: "Costs 6.50€, Max. 30kg box",
      delivery:
        "Delivered within Munich (0-1 day), Rest of Germany (1-2 days) (Excluding holidays)",
    },
  ];
  return (
    <div className={styles.product_delivery_info}>
      {info.map((item, index) => (
        <Fragment key={index}>
          <div className={styles.product_delivery_info_item}>
            <div>
              <span style={{ fontWeight: "600" }}> {item.title} </span>{" "}
              <span> ({item.from}) </span>
            </div>
            <div> {item.delivery} </div>
          </div>
          {isDesktop && index !== info.length - 1 && (
            <Divider style={{ margin: "1rem 0" }} />
          )}
        </Fragment>
      ))}
    </div>
  );
};

const DiscountPopContent = ({ quantity, price }) => {
  const freeDeliveryThreshold = 49;
  const orderTotal = Number(quantity) * Number(price);
  const percentage = Math.floor((orderTotal / freeDeliveryThreshold) * 100);

  return (
    <div>
      <Progress
        percent={percentage}
        strokeColor={{
          "0%": "#318449",
          "100%": "#A9C27E",
        }}
        format={() => `${orderTotal.toFixed(2)}€`}
        className={
          orderTotal > 22.32
            ? "discount_progress_bar_white"
            : "discount_progress_bar_black"
        }
      />
      <div>
        {orderTotal < freeDeliveryThreshold ? (
          <span>
            <strong>
              Add{" "}
              {(freeDeliveryThreshold - orderTotal).toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              €{" "}
            </strong>{" "}
            more to get free shipping
          </span>
        ) : (
          <span>You have obtained free shipping.</span>
        )}
      </div>
    </div>
  );
};

// report false modal
const ReportFalseModal = ({ visible, setVisible, productId }) => {
  const [loading, setLoading] = useState(false);
  const reportFalse = async (values) => {
    const payload = {
      ...values,
      subject: `Report False/Incorrect For Product ${productId}`,
    };

    try {
      setLoading(true);
      await axios.post("/contact-us/submit", payload);
      message.success("Your feedback is recorded.Thank you.");
      setVisible(false);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Describe Your Reason"
      open={visible}
      onCancel={() => {
        setVisible(false);
      }}
      centered
      footer={null}
    >
      <Form
        onFinish={reportFalse}
        layout="vertical"
        scrollToFirstError
        requiredMark={false}
      >
        <Form.Item
          label="Your Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please input your name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              type: "email",
              message: "The input is not valid Email!",
            },
            {
              required: true,
              message: "Please input your Email!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="message"
          label="Describe Issue"
          rules={[
            {
              required: true,
              message: "Please describe your issue!",
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item className="mb-0">
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            disabled={loading}
          >
            Send
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
